import React, { useEffect, useState } from 'react';
import { Package } from 'lucide-react';
import { Card, Btn, Select, Table, Spinner, ErrBox } from '../../../components/UI';
import { inventoryAPI } from '../../../utils/api';
import { fmtRp } from '../../../utils/format';

export default function StockTab() {
  const [stock, setStock] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({ item_id: '', location_id: '' });
  const [locations, setLocations] = useState([]);
  const [items, setItems] = useState([]);

  useEffect(() => { loadStock(); loadRefs(); }, []);

  const loadRefs = async () => {
    try {
      const [loc, itm] = await Promise.all([
        inventoryAPI.getLocations(),
        inventoryAPI.getItems('?limit=100'),
      ]);
      setLocations((loc.data || []).map(x => ({ value: x.id, label: x.nama })));
      setItems((itm.data || []).map(x => ({ value: x.id, label: x.nama })));
    } catch {}
  };

  const loadStock = async () => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams();
      if (filters.item_id) params.append('item_id', filters.item_id);
      if (filters.location_id) params.append('location_id', filters.location_id);
      const r = await inventoryAPI.getStock(filters);
      setStock(r.data || []);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const getStatusBadge = (onHand, minStok, reserved) => {
    const available = Number(onHand || 0) - Number(reserved || 0);
    if (available <= Number(minStok || 0)) return <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#FEF2F2', color: '#DC2626' }}>DI BAWAH MIN</span>;
    if (available <= Number(minStok || 0) * 1.5) return <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#FFFBEB', color: '#D97706' }}>WARNING</span>;
    return <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#ECFDF5', color: '#059669' }}>OK</span>;
  };

  return (
    <div>
      <div style={{ display: 'flex', gap: 12, marginBottom: 16, alignItems: 'flex-end' }}>
        <div style={{ minWidth: 200 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#6B7280', marginBottom: 4 }}>Filter Barang</label>
          <Select value={filters.item_id} onChange={e => setFilters({ ...filters, item_id: e.target.value })} options={[{ value: '', label: 'Semua barang' }, ...items]} />
        </div>
        <div style={{ minWidth: 200 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: '#6B7280', marginBottom: 4 }}>Filter Lokasi</label>
          <Select value={filters.location_id} onChange={e => setFilters({ ...filters, location_id: e.target.value })} options={[{ value: '', label: 'Semua lokasi' }, ...locations]} />
        </div>
        <Btn onClick={loadStock}>Cari</Btn>
        <Btn variant="ghost" onClick={() => setFilters({ item_id: '', location_id: '' })}>Reset</Btn>
      </div>

      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#111827' }}>
            <Package size={18} style={{ marginRight: 8, verticalAlign: 'middle' }} />
            Stok Saat Ini ({stock.length})
          </h3>
        </div>

        {error && <div style={{ marginBottom: 12 }}><ErrBox msg={error} onRetry={loadStock} /></div>}
        {loading ? <Spinner /> : stock.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9CA3AF' }}>
            <Package size={40} style={{ marginBottom: 12, opacity: 0.4 }} />
            <p style={{ margin: 0 }}>Tidak ada data stok</p>
          </div>
        ) : (
          <Table pageSize={10} cols={[
            { key: 'item_kode', label: 'Kode', nowrap: true },
            { key: 'item_nama', label: 'Nama Barang' },
            { key: 'warehouse_nama', label: 'Lokasi' },
            { key: 'qty_on_hand', label: 'On Hand', align: 'right' },
            { key: 'qty_reserved', label: 'Reserved', align: 'right' },
            { key: 'min_stok', label: 'Min', align: 'right' },
            { key: 'max_stok', label: 'Max', align: 'right' },
            { key: 'stock_status', label: 'Status', render: (v, row) => getStatusBadge(row.qty_on_hand, row.min_stok, row.qty_reserved) },
          ]} data={stock} emptyMsg="Tidak ada data stok" />
        )}
      </Card>
    </div>
  );
}